// import { getToken, setToken, getRootDomain } from '@/utils/auth'
import {
  Message
} from 'element-ui'

import {
  syncGetToken
} from '../../utils/auth' // getToken from cookie

// import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr'

// let mgr = new Mgr()
let accessToken = null

const baseUrl = window.SERVERAPI.API_RULES
const signalR = window.signalR
const user = {
  state: {
    connection: null
  },

  mutations: {
    SET_CONNECTION(state, connection) {
      state.connection = connection
    }
  },

  actions: {
    WebStockInit({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        if(!baseUrl) {
          resolve()
          return
        }
        let connection = new signalR.HubConnectionBuilder()
          .withUrl(baseUrl + '/DataCenterHub', {
            accessTokenFactory: async() => {
              if (accessToken === null) {
                return await syncGetToken().then(
                  acessToken => {
                    let { token } = acessToken
                    accessToken = token
                    return token
                  }, err => {
                    console.log(err)
                    return null
                  })
              }
              return accessToken
            }
          })
          .configureLogging(signalR.LogLevel.Information)
          .build()
        // connection.Headers.Add('Access-Control-Allow-Origin', '*')
        // connection.Headers.Add('Authorization', 'Bearer ' + getToken())
        commit('SET_CONNECTION', connection)
        dispatch('Start')
        resolve()
      })
    },
    // ProgressReceiveMessage 推送任务进度
    ProgressReceiveMessage({ commit, state }, callback) {
      return new Promise((resolve, reject) => {
        resolve(state.connection.on('ProgressReceiveMessage', res => {
          let { data, succeed, code, msg } = res
          if (succeed && code === 0) {
            callback(data)
          } else {
            if (msg) {
              Message({
                message: msg,
                type: 'warning',
                duration: 2000
              })
              reject(data)
            }
          }
        }))
      })
    },
    Stop({ state }) {
      return new Promise((resolve, reject) => {
        state.connection.stop()
      })
    },
    OnClose({ dispatch, state }) {
      return new Promise((resolve, reject) => {
        state.connection.onclose(async() => {
          await dispatch('Start')
        })
      })
    },
    Start({ commit, state, dispatch }) {
      return new Promise(async(resolve, reject) => {
        try {
          await state.connection.start()
          console.log('connected')
          resolve()
        } catch (err) {
          console.log('err', err)
          setTimeout(() => {
            console.log('err try Start', err)
            dispatch('Start')
          }, 5000)
        }
      })
    }
  }
}

export default user
